import styled from 'styled-components';

export const ImageWrapper = styled('img')`
  height: 100px;
  width: 100px;
  object-fit: cover;
  max-width: 100%;
  display: block;
`;
